module.exports = __webpack_public_path__ + "img/ck-mutil-star5-bg.5f36b3a6.png";